@@ -1,546 +1,546 @@
<template>
  <div
    :class="
      navigation || culturePop
        ? 'popup'
        : '' || startProjectPop || recruitPop
        ? 'popup black'
        : '' || awardsPop
        ? 'black-gra'
        : ''
    "
    class="container viewPage titleistMView"
  >
    <header-area />

    <div class="worksView">
      <div class="contsBox">
        <div class="viewInCon">
          <div class="workTopTitle">
            <div class="workSlogan web">Digital<br />Transformation</div>
            <div class="workSlogan mobile">Digital<br />Transformation</div>
            <div class="workTopDay">
              <p>타이틀리스트 인터랙티브 채널 마케팅 대행</p>
              <ul>
                <li>Digital Marketing</li>
                <li>2013 - 2021</li>
              </ul>
            </div>
            <div class="workTopSns">
              <a href="https://titleistapparel.co.kr" target="_blank" class="siteAddr"
                >https://titleistapparel.co.kr/</a
              >
              <ul>
                <li>
                  <social-sharing
                    url="https://www.pulip.com/sns/titleist-m"
                    title="타이틀리스트 인터랙티브 채널 마케팅 대행"
                    hashtags="디지털 마케팅 플랫폼을 향한 8년간의 여정, 타이틀리스트 인터랙티브 채널"
                    twitter-user="디지털 마케팅 플랫폼을 향한 8년간의 여정, 타이틀리스트 인터랙티브 채널 #플립커뮤니케이션즈 #타이틀리스트"
                    inline-template
                  >
                    <network network="facebook">
                      <a href="javascript:;" class="wFacebook">
                        <img src="@/assets/images/@sns_fb_w.png" alt="" />
                      </a>
                    </network>
                  </social-sharing>
                </li>
                <li>
                  <social-sharing
                    url="https://www.pulip.com/sns/titleist-m"
                    title="타이틀리스트 인터랙티브 채널 마케팅 대행"
                    hashtags="디지털 마케팅 플랫폼을 향한 8년간의 여정, 타이틀리스트 인터랙티브 채널"
                    twitter-user="디지털 마케팅 플랫폼을 향한 8년간의 여정, 타이틀리스트 인터랙티브 채널 #플립커뮤니케이션즈 #타이틀리스트"
                    inline-template
                  >
                    <network network="twitter">
                      <a href="javascript:;" class="wTweeter">
                        <img src="@/assets/images/@sns_tw_w.png" alt="" />
                      </a>
                    </network>
                  </social-sharing>
                </li>
                <li>
                  <a href="javascript:;" @click.prevent="doCopy" class="wChain">
                    <img src="@/assets/images/@web_link_w.png" alt="" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="workVisual">
        <div class="workImg">
          <span class="workMoveTxt"
            ><marquee-text :duration="16">&nbsp;8 years of evolution</marquee-text></span
          >
          <img
            class="web"
            src="@/assets/images/works_view/titleist_h/titleist_h_visual.jpg"
            alt=""
          />
          <img
            class="mobile"
            src="@/assets/images/works_view/titleist_h/titleist_h_visual_m.jpg"
            alt=""
          />
        </div>
      </div>
      <div class="bgColorTop">
        <div class="contsBox">
          <div class="topInfo">
            <div class="web">
              디지털을 통해 타이틀리스트를 사랑하는 골퍼(Target Audience)를<br />찾아(Lead) 새로운
              브랜드 경험으로 연결(Conversion)합니다.
            </div>
            <div class="mobile">
              디지털을 통해 타이틀리스트를 사랑하는 골퍼(Target Audience)를 찾아(Lead)<br />새로운
              브랜드 경험으로<br />연결(Conversion)합니다.
            </div>
          </div>
          <p>
            2013년 3월, 타이틀리스트 브랜드를 사랑하는 골퍼를 찾는 8년간의 여정이 시작되었습니다.
            타이틀리스트는 글로벌 No.1 골프용품 브랜드라는 현재의 위치에 만족하지 않고 디지털을 통해
            고객과의 관계를 발전시키기를 바랐습니다. 타이틀리스트를 사랑하는 골퍼를 이해하고 그들의
            골프 라이프에 도움을 줄 수 있는 장비, 지식, 콘텐츠를 제공할 수 있는 데이터 기반의 디지털
            마케팅 서비스 플랫폼을 계획하고 제공했습니다.
          </p>
          <div class="titleistLogo">
            <img src="@/assets/images/works_view/titleist_h/titleist_logo.png" alt="" />
          </div>
        </div>
      </div>
    </div>

    <div class="wideConts">
      <div class="titleistMBox">
        <div class="worksView">
          <div class="phaseList">
            <div class="sec1Slider swiper-container">
              <div class="swiper-wrapper">
                <div class="swiper-slide startShow">
                  <span class="">Digital <br />Transformation</span>
                  <p>디지털 마케팅 플랫폼으로의 <br />8년의 여정</p>
                  <img src="@/assets/images/works_view/titleist_h/titleist_scroll.png" alt="" />
                </div>
                <div class="swiper-slide">
                  <strong class="title">타겟 오디언스 접점<br />플랫폼 고도화</strong>
                  <div class="phaseBox">
                    <em class="num">phase 1</em>
                    <div class="bar" />
                    <span class="year first">2013</span>
                    <span class="year second">2014</span>
                    <span class="year third">2015</span>
                  </div>
                  <ul class="bullet">
                    <li class="phase1-1" :class="{ active: over1 === 0 }" @mouseenter="over1 = 0">
                      타이틀리스트 통합 APP 구축
                      <span class="img"
                        ><img src="@/assets/images/works_view/titleist_h/phase1_img01.png" alt=""
                      /></span>
                    </li>
                    <li class="phase1-2" :class="{ active: over1 === 1 }" @mouseenter="over1 = 1">
                      타이틀리스트 어패럴 멤버십 APP 구축
                      <span class="img"
                        ><img src="@/assets/images/works_view/titleist_h/phase1_img02.png" alt=""
                      /></span>
                    </li>
                    <li class="phase1-3" :class="{ active: over1 === 2 }" @mouseenter="over1 = 2">
                      팀 타이틀리스트 웹사이트 1차 개편
                      <span class="img"
                        ><img src="@/assets/images/works_view/titleist_h/phase1_img03.png" alt=""
                      /></span>
                    </li>
                    <li class="phase1-4" :class="{ active: over1 === 3 }" @mouseenter="over1 = 3">
                      SNS 채널 개설 & 타겟 오디언스 증대 활동
                      <span class="img"
                        ><img src="@/assets/images/works_view/titleist_h/phase0_img00.png" alt=""
                      /></span>
                    </li>
                  </ul>
                </div>
                <div class="swiper-slide">
                  <strong class="title"
                    >타겟 오디언스 증대 &<br />온/오프라인 브랜드 경험 확대</strong
                  >
                  <div class="phaseBox">
                    <em class="num">phase 2</em>
                    <div class="bar" />
                    <span class="year first">2016</span>
                    <span class="year second">2017</span>
                  </div>
                  <ul class="bullet">
                    <li class="phase2-1" :class="{ active: over2 === 0 }" @mouseenter="over2 = 0">
                      멤버십 제휴를 통한 오디언스 증대 활동
                      <span class="img"
                        ><img src="@/assets/images/works_view/titleist_h/phase0_img00.png" alt=""
                      /></span>
                    </li>
                    <li class="phase2-2" :class="{ active: over2 === 1 }" @mouseenter="over2 = 1">
                      타이틀리스트 제품 & 서비스 체험을 위한 <br />옴니채널 플랫폼 구축
                      <span class="img"
                        ><img src="@/assets/images/works_view/titleist_h/phase2_img02.png" alt=""
                      /></span>
                    </li>
                    <li class="phase2-3" :class="{ active: over2 === 2 }" @mouseenter="over2 = 2">
                      타이틀리스트 제품 & 서비스 체험 활동 <br />콘텐츠 생성 및 배포
                      <span class="img"
                        ><img src="@/assets/images/works_view/titleist_h/phase2_img03.png" alt=""
                      /></span>
                    </li>
                  </ul>
                </div>
                <div class="swiper-slide">
                  <strong class="title">데이터 마케팅 인프라 구축 및 <br />고도화</strong>
                  <div class="phaseBox">
                    <em class="num">phase 3</em>
                    <div class="bar" />
                    <span class="year first">2017</span>
                    <span class="year second">2018</span>
                    <span class="year third">2019</span>
                  </div>
                  <ul class="bullet">
                    <li class="phase3-1" :class="{ active: over3 === 0 }" @mouseenter="over3 = 0">
                      고객 이용행태 분석 플랫폼으로 개선 : <br />팀 타이틀리스트 웹사이트 2차 개편
                      <span class="img"
                        ><img src="@/assets/images/works_view/titleist_h/phase0_img00.png" alt=""
                      /></span>
                    </li>
                    <li class="phase3-2" :class="{ active: over3 === 1 }" @mouseenter="over3 = 1">
                      고객 리드 및 분석을 위한 마케팅 솔루션 도입
                      <span class="img"
                        ><img src="@/assets/images/works_view/titleist_h/phase0_img00.png" alt=""
                      /></span>
                    </li>
                    <li class="phase3-3" :class="{ active: over3 === 2 }" @mouseenter="over3 = 2">
                      타이틀리스트 오프라인 서비스 시스템 <br />디지털 플랫폼으로 전환 구축
                      <span class="img"
                        ><img src="@/assets/images/works_view/titleist_h/phase3_img03.png" alt=""
                      /></span>
                    </li>
                    <li class="phase3-4" :class="{ active: over3 === 3 }" @mouseenter="over3 = 3">
                      오프라인 체험 활동 데이터 분석 시스템 구현
                      <span class="img"
                        ><img src="@/assets/images/works_view/titleist_h/phase0_img00.png" alt=""
                      /></span>
                    </li>
                  </ul>
                </div>
                <div class="swiper-slide">
                  <strong class="title">데이터 드리븐 & <br />콘텐츠 마케팅 플랫폼</strong>
                  <div class="phaseBox">
                    <em class="num">phase 4</em>
                    <div class="bar" />
                    <span class="year first">2020 ~</span>
                  </div>
                  <ul class="bullet">
                    <li class="phase4-1" :class="{ active: over4 === 0 }" @mouseenter="over4 = 0">
                      고객 데이터 기반 컨시어지 서비스 구축
                      <span class="img"
                        ><img src="@/assets/images/works_view/titleist_h/phase4_img01.png" alt=""
                      /></span>
                    </li>
                    <li class="phase4-2" :class="{ active: over4 === 1 }" @mouseenter="over4 = 1">
                      골프볼 연간 마케팅 캠페인으로 브랜디드 <br />콘텐츠 생산 & 확산
                      <span class="img"
                        ><img src="@/assets/images/works_view/titleist_h/phase4_img02.png" alt=""
                      /></span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div
            class="countList"
            v-observe-visibility="(isVisible, entry) => scoreObserveActive10(isVisible, entry)"
          >
            <div class="contsBox">
              <div class="txtBox">
                <strong class="title">8 years of <br />evolution</strong>
                <p>온라인에서도 디지털 트랜스포메이션으로 <br />업계를 선도하다</p>
              </div>
              <div class="countTotal">
                <div
                  class="totalBox"
                  v-observe-visibility="
                    (isVisible, entry) => scoreObserveActive01(isVisible, entry)
                  "
                >
                  <span class="sub">Target Audience</span>
                  <span class="vol">Volume</span>
                  <div class="count">
                    <strong class="num">{{ scorePlay01.score }}</strong>
                    <em class="unit">%</em>
                  </div>
                </div>
                <div
                  class="totalBox"
                  v-observe-visibility="
                    (isVisible, entry) => scoreObserveActive02(isVisible, entry)
                  "
                >
                  <span class="sub">SNS (Facebook)</span>
                  <span class="vol">Volume</span>
                  <div class="count">
                    <strong class="num">{{ scorePlay02.score }}</strong>
                    <em class="unit">%</em>
                  </div>
                </div>
                <div
                  class="totalBox figuresType"
                  v-observe-visibility="
                    (isVisible, entry) => scoreObserveActive03(isVisible, entry)
                  "
                >
                  <span class="sub">Figures</span>
                  <span class="vol">2013</span>
                  <div class="count">
                    <strong class="num">{{ scorePlay03.score }}</strong>
                    <em class="unit">억</em>
                  </div>
                </div>
                <div
                  class="totalBox figuresType"
                  v-observe-visibility="
                    (isVisible, entry) => scoreObserveActive04(isVisible, entry)
                  "
                >
                  <span class="vol">2020</span>
                  <div class="count">
                    <strong class="num">{{ scorePlay04.score }}</strong>
                    <em class="unit">억</em>
                  </div>
                </div>
              </div>
            </div>
            <ul
              class="progressBarList"
              v-observe-visibility="(isVisible, entry) => observeActive(isVisible, entry)"
            >
              <li><span class="year">2012</span><span class="bar" /></li>
              <li><span class="year">2013</span><span class="bar" /></li>
              <li><span class="year">2014</span><span class="bar" /></li>
              <li><span class="year">2015</span><span class="bar" /></li>
              <li><span class="year">2016</span><span class="bar" /></li>
              <li><span class="year">2017</span><span class="bar" /></li>
              <li><span class="year">2018</span><span class="bar" /></li>
              <li><span class="year">2019</span><span class="bar" /></li>
              <li><span class="year">2020</span><span class="bar" /></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="titleistMEnd">
        <div class="contsBox">
          <div class="endTitle">A successful digital transformation partner</div>
          <p>
            빠르게 변화하는 4차 산업혁명의 시대 기업의 디지털 트랜스포메이션은 기업의 생존을 좌우 할
            수 있는 전략이며, 선택이 아닌 필수입니다.
            <br />플립커뮤니케이션즈는 성공적인 디지털 트랜스포메이션 전략과 수행 경험을 제공합니다.
          </p>
          <a href="https://www.pulip.com/contact" target="_blank"
            >디지털 트랜스포메이션 더 알아보기</a
          >
        </div>
      </div>
    </div>

    <div class="worksView">
      <div class="contsBox">
        <div class="backToList">
          <router-link :to="{ name: 'works' }" class="backBtn">
            <img src="@/assets/images/@ico_back_x2.jpg" alt="" />
            <span>Back to list</span>
          </router-link>
        </div>
      </div>

      <router-link v-if="true" :to="{ name: 'works-ioneB' }" class="longEnd vType">
        <div class="viewType">
          <span>next</span>
          <strong class="web">IBK기업은행 i-ONE Bank Global</strong>
          <strong class="mobile">IBK기업은행<br />i-ONE Bank Global</strong>
        </div>

        <div class="engBg kiwoomEndBg">
          <span />
        </div>
      </router-link>
    </div>

    <footer-area />
  </div>
</template>

<script>
import Vue from "vue";
import { mapState } from "vuex";
import HeaderArea from "@/components/Header";
import FooterArea from "@/components/Footer";
import common from "@/shared/mixin/common.js";
import MarqueeText from "vue-marquee-text-component";
import { TweenLite } from "gsap/all";

export default {
  mixins: [common],
  name: "Main",
  /* head: {
    title: {
      inner: '타이틀리스트 인터랙티브 채널 마케팅 대행'
    }
  }, */
  head: {
    title: function() {
      return {
        inner: this.meta.title
      };
    },
    meta: function() {
      return [
        {
          name: "description",
          content: this.meta.desc
        },
        {
          name: "keywords",
          content: this.meta.keywords
        },
        // Open Graph
        { property: "og:title", content: this.meta.title },
        { property: "og:description", content: this.meta.desc },
        { property: "og:type", content: "website" },
        { property: "og:url", content: this.meta.url },
        { property: "og:image", content: this.meta.img },

        // Additional OG tags
        { property: "og:site_name", content: this.meta.siteName }
      ];
    }
  },
  components: {
    HeaderArea,
    FooterArea,
    MarqueeText
  },
  data() {
    return {
      meta: {
        siteName: "타이틀리스트 어패럴 온라인 마케팅 | 플립커뮤니케이션즈",
        title: "타이틀리스트 어패럴 온라인 마케팅",
        desc:
          "타이틀리스트를 사랑하는 골퍼를 찾아 새로운 브랜드 경험으로 연결하는 디지털 마케팅 플랫폼을 구축했습니다. 타이틀리스트를 이해하고 골프 라이프에 도움을 줄 수 있는 장비, 지식, 콘텐츠를 제공할 수 있는 데이터 기반의 디지털 마케팅 서비스 플랫폼으로 고도화했습니다.",
        keywords:
          "타이틀리스트, 인터랙티브 채널, 마케팅 대행, 디지털 마케팅, 골퍼, 브랜드 경험, 데이터 기반, 옴니채널 플랫폼, 멤버십 제휴, 콘텐츠 생성, 데이터 마케팅 인프라, 이용행태 분석, 마케팅 솔루션, 고객 데이터 기반, 디지털 트랜스포메이션",
        url: "https://www.pulip.com/works/TitleistM",
        img: "https://www.pulip.com/pulip-logo.jpg"
      },
      W: 0,
      sec1Slider: null,
      icoInter: null,
      icoVal: 0,
      over1: 0,
      over2: 0,
      over3: 0,
      over4: 0,
      scorePlay01: { score: 0, complete: true },
      scorePlay02: { score: 0, complete: true },
      scorePlay03: { score: 0, complete: true },
      scorePlay04: { score: 0, complete: true },
      active: false
    };
  },
  computed: {
    ...mapState("common", {
      readyAction: state => state.readyAction,
      startProjectPop: state => state.startProjectPop,
      recruitPop: state => state.recruitPop,
      awardsPop: state => state.awardsPop,
      culturePop: state => state.culturePop,
      navigation: state => state.navigation
    }),
    W2() {
      return this.W / 2;
    },
    W3() {
      return this.W / 3;
    },
    W4() {
      return this.W / 4;
    }
  },
  methods: {
    scoreObserveActive01(isVisible) {
      const scoreEnd = 996;
      if (isVisible) {
        if (this.scorePlay01.complete) {
          this.scorePlay01.complete = false;
          TweenLite.to(this.scorePlay01, 2, { score: scoreEnd, roundProps: "score" });
        }
      } else {
        this.scorePlay01.score = 0;
        this.scorePlay01.complete = true;
      }
    },
    scoreObserveActive02(isVisible) {
      const scoreEnd = 379;
      if (isVisible) {
        if (this.scorePlay02.complete) {
          this.scorePlay02.complete = false;
          TweenLite.to(this.scorePlay02, 2, { score: scoreEnd, roundProps: "score" });
        }
      } else {
        this.scorePlay02.score = 0;
        this.scorePlay02.complete = true;
      }
    },
    scoreObserveActive03(isVisible) {
      const scoreEnd = 1169;
      if (isVisible) {
        if (this.scorePlay03.complete) {
          this.scorePlay03.complete = false;
          TweenLite.to(this.scorePlay03, 1.5, { score: scoreEnd, roundProps: "score" });
        }
      } else {
        this.scorePlay03.score = 0;
        this.scorePlay03.complete = true;
      }
    },
    scoreObserveActive04(isVisible) {
      const scoreEnd = 2914;
      if (isVisible) {
        if (this.scorePlay04.complete) {
          this.scorePlay04.complete = false;
          TweenLite.to(this.scorePlay04, 1.5, { score: scoreEnd, roundProps: "score" });
        }
      } else {
        this.scorePlay04.score = 0;
        this.scorePlay04.complete = true;
      }
    },
    scoreObserveActive10(isVisible) {
      this.sec1Slider.mousewheel.enable();
    },
    doCopy() {
      this.$copyText("https://www.pulip.com/sns/TitleistM").then(
        function(e) {
          alert("복사되었습니다.");
          console.log(e);
        },
        function(e) {
          console.log(e);
        }
      );
    },
    handleResize() {
      this.W = window.innerWidth;
      this.H = window.innerHeight;
    },
    visibilityChanged(isVisible, entry) {
      // this.isVisible = isVisible
      console.log(entry);
    }
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    this.sec1Slider.destroy();
    window.removeEventListener("resize", this.handleResize);
    clearInterval(this.icoInter);
  },
  mounted() {
    const _slef = this;
    this.sec1Slider = new window.Swiper(".sec1Slider.swiper-container", {
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      mousewheel: true,
      slidesPerView: "auto",
      centeredSlides: false,
      speed: 1000,
      breakpoints: {
        // when window width is >= 640px
        760: {
          centeredSlides: true
        }
      },
      on: {
        slideChange: function(e) {
          if (_slef.sec1Slider.activeIndex === 4)
            setTimeout(_ => {
              _slef.sec1Slider.mousewheel.disable();
            }, 1000);
          else _slef.sec1Slider.mousewheel.enable();
        }
      }
    });
  }
};
</script>
